// Root page for humans; the widget itself only renders inside a Bloomreach Webhook preset at /widget.
const Landing = () => {
  const widgetUrl = `${window.location.origin}/bloomreach/widget?orgId=<orgId>`;
  return (
    <div className="br-shell__center-message" data-testid="bloomreach-landing">
      <h2>Gupshup WhatsApp for Bloomreach</h2>
      <p>This app runs inside a Bloomreach Webhook preset.</p>
      <p>
        Widget URL: <code>{widgetUrl}</code>
      </p>
    </div>
  );
};

export default Landing;
